/* global window */

import moment from 'moment';

const currentLanguage = window.siteData.language || 'da';

import './ResumeItem.scss';
import template from './ResumeItem.vhtml';

export default {
	name: 'ResumeItem',
	template: template,
	props: {
		'resume': {
			type: Object,
		},
	},
	data: () => ({
		showDetails: false,
	}),
	methods: {
		formatDate(date) {
			return formatDate(date, currentLanguage);
		},
		toggleDetails() {
			this.showDetails = !this.showDetails;
		}
	},
};

function formatDate(date, lang = 'en', format = 'll') {
	// Set locale
	moment.locale(lang);
	return moment(date).format(format);
}
